var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_803_25161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_803_25161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40375 18V17H14.6578C15.6949 17 16.5786 16.6442 17.3087 15.9327C18.0387 15.2212 18.4038 14.3527 18.4038 13.327C18.4038 12.3013 18.0387 11.4359 17.3087 10.7307C16.5786 10.0256 15.6949 9.673 14.6578 9.673H6.9155L9.88075 12.6385L9.173 13.3463L5 9.173L9.173 5L9.88075 5.70775L6.9155 8.673H14.6578C15.9668 8.673 17.085 9.12433 18.0125 10.027C18.94 10.9295 19.4038 12.0295 19.4038 13.327C19.4038 14.6243 18.94 15.7275 18.0125 16.6365C17.085 17.5455 15.9668 18 14.6578 18H7.40375Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.964ef9a5c997d8703d3c658845362a77.svg";
export { ForwardRef as ReactComponent };